import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-scroll";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import "./Navbar.css";
import logo from "../../Assets/Mainpage/logo2.png";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "Home", to: "home" },
    { name: "About Me", to: "skill" },
    { name: "Projects", to: "project" },
    { name: "Contact", to: "contact" },
  ];

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}
    >
      <div className="navbar-container">
        {/* Logo */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="navbar-logo"
        >
          <Link to="home">
            <img src={logo} alt="Logo" className="logo" />
          </Link>
        </motion.div>

        {/* Desktop Menu */}
        <div className="navbar-menu">
          {navItems.map((item, i) => (
            <motion.div
              key={item.to}
              initial={{ opacity: 0, y: -20 }}
              transition={{ delay: i * 0.1 + 0.5 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Link
                className="navbar-link"
                to={item.to}
                smooth={true}
                duration={500}
                offset={-80}
                spy={true}
                activeClass="active"
              >
                <span className="navbar-link-text">{item.name}</span>
                <span className="navbar-link-underline" />
              </Link>
            </motion.div>
          ))}
        </div>

        {/* Contact Button */}
        <motion.a
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.8 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="navbar-cta"
          href="https://wa.me/+6285857321597?text=Hello%20Willy,%20I%20visited%20your%20website!"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="navbar-cta-icon" />
          <span>Let's Talk</span>
        </motion.a>

        {/* Mobile Menu Button */}
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="mobile-menu-btn"
          onClick={() => setShowMenu(!showMenu)}
        >
          {showMenu ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
        </motion.button>
      </div>

      {/* Mobile Button */}
      <AnimatePresence>
        {showMenu && (
          <motion.div>
            {navItems.map((item) => (
              <motion.div key={item.to} variants={itemVariants}>
                <Link
                  className="mobile-menu-link"
                  onClick={() => setShowMenu(false)}
                  to={item.to}
                  smooth={true}
                  duration={500}
                  offset={-80}
                >
                  <span>{item.name}</span>
                  <motion.div
                    className="mobile-menu-arrow"
                    whileHover={{ x: 5 }}
                  >
                    →
                  </motion.div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
